// xml.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class XmlParser {
  readonly #parser = new DOMParser();
  readonly #serializer = new XMLSerializer();
  readonly #xsltDoc = this.#parser.parseFromString(
    `<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
  <xsl:strip-space elements="*"/>
  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nod
    <xsl:value-of select="normalize-space(.)"/>
  </xsl:template>
  <xsl:template match="node()|@*">
    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>
  </xsl:template>
  <xsl:output indent="yes"/>
</xsl:stylesheet>`,
    'application/xml'
  );
  readonly #xsltDoc2 = this.#parser.parseFromString(
    `<xsl:stylesheet version="1.0"
 xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
 <xsl:output omit-xml-declaration="yes" indent="yes"/>

    <xsl:template match="node()|@*">
      <xsl:copy>
        <xsl:apply-templates select="node()|@*"/>
      </xsl:copy>
    </xsl:template>
</xsl:stylesheet>`,
    'application/xml'
  );

  #xsltProcessor = new XSLTProcessor();

  constructor() {
    this.#xsltProcessor.importStylesheet(this.#xsltDoc);
  }

  readBlobAsText(blob: Blob): Observable<string> {
    return new Observable<string>((observer) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        observer.next(reader.result as string);
        observer.complete();
      };

      reader.onerror = (error) => {
        observer.error(error);
      };

      reader.readAsText(blob);
    });
  }

  parseXml(xmlText: string): Document {
    const xml = this.#parser.parseFromString(xmlText, 'application/xml');
    return xml.documentElement.tagName === 'html' ? null : xml;
  }

  prettify(xmlText: string): string {
    let xml = this.parseXml(xmlText);
    xml = this.#xsltProcessor.transformToDocument(xml);
    return this.#serializer.serializeToString(xml);
  }
}
